import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ceb',
  months: [
    'Enero',
    'Pebrero',
    'Marso',
    'Abril',
    'Mayo',
    'Hunyo',
    'Hulyo',
    'Agosto',
    'Setyembre',
    'Oktubre',
    'Nobyembre',
    'Disyembre',
  ],
  monthsShort: ['Ene', 'Peb', 'Mar', 'Abr', 'May', 'Hun', 'Hul', 'Ago', 'Set', 'Okt', 'Nob', 'Dis'],
  weekdays: ['Domingo', 'Lunes', 'Martes', 'Miyerkules', 'Huwebes', 'Biyernes', 'Sabado'],
  weekdaysMin: ['D', 'L', 'M', 'M', 'H', 'B', 'S'],
  weekdaysShort: ['Dom', 'Lun', 'Mar', 'Miy', 'Huw', 'Biy', 'Sab'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'M/DD/YYYY',
    LL: 'MMMM D, YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'MMMM D',
    LLL: 'MMMM D, YYYY HH:mm',
    'LLL-Y': 'MMMM D HH:mm',
    LLLL: 'dddd MMMM D, YYYY HH:mm',
    'LLLL-Y': 'dddd MMMM D HH:mm',
    l: 'M/D/YYYY',
    'l-Y': 'M/D',
    ll: 'MMM D, YYYY',
    'll-Y': 'MMM D',
    lll: 'MMM D, YYYY h:mm A',
    'lll-Y': 'MMM D h:mm A',
    llll: 'ddd MMM D, YYYY h:mm A',
    'llll-Y': 'ddd MMM D h:mm A',
    'll-Y+w': 'ddd, MMM D',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'MMMM D, YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { other: '-%s y' },
    M: { other: '-%s m' },
    w: { other: '-%s w' },
    d: { other: '-%s d' },
    h: { other: '-%s h' },
    m: { other: '-%s min' },
    s: { other: '-%s s' },
  },
  future: {
    y: { other: '+%s y' },
    M: { other: '+%s m' },
    w: { other: '+%s w' },
    d: { other: '+%s d' },
    h: { other: '+%s h' },
    m: { other: '+%s min' },
    s: { other: '+%s s' },
  },
  abbr: {
    y: { one: '%stuig', other: '%stuig' },
    M: { one: '%sb', other: '%sb' },
    w: { one: '%ssem', other: '%ssem' },
    d: { one: '%sa', other: '%sa' },
    h: { one: '%so', other: '%so' },
    m: { one: '%smin', other: '%smin' },
    s: { one: '%sseg', other: '%sseg' },
  },
  justNow: 'Karon lang',
  yesterday: 'Kagahapon',
  today: 'Karong adlawa',
  tomorrow: 'Ugma',
  weekStart: 0,
};
const localeName: LocaleName = 'ceb';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
